module.exports = __webpack_public_path__ + "img/multi-select.1df6e0ab.svg";